import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

export const useUnsavedChangesWarning = (
  shouldWarn,
  { shouldBlockNavigation = null } = {}
) => {
  const shouldWarnRef = useRef(shouldWarn);
  shouldWarnRef.current = shouldWarn;

  const shouldBlockNavigationRef = useRef(shouldBlockNavigation);
  shouldBlockNavigationRef.current = shouldBlockNavigation;

  const history = useHistory();

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldWarnRef.current) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (!shouldWarnRef.current) {
        return true;
      }

      const shouldBlock = shouldBlockNavigationRef.current
        ? shouldBlockNavigationRef.current(location, action)
        : true;

      if (!shouldBlock) {
        return true;
      }

      return window.confirm(
        'You have unsaved changes. Do you want to leave without saving?'
      );
    });

    return unblock;
  }, [history]);
};
